// @flow
// eslint-env browser
import { CoreService as CoreServiceBase } from '../common/core-service';

export class CoreService extends CoreServiceBase {
    static getInstance(): CoreService {
        window.__ark_ads__ = window.__ark_ads__ || {};
        window.__ark_ads__.coreServiceInstance = window.__ark_ads__.coreServiceInstance || new CoreService();
        window.__ark_ads__.displayAd = {};
        return window.__ark_ads__.coreServiceInstance;
    }

    timeout: TimeoutID;

    refreshTime = 60000;

    refreshTimeout: TimeoutID;

    beforeProcessQueue = () => {
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
        this.beforeProcessQueue = () => undefined;
    }
}

export function applyWideAdWorkaround() {
    // The Big Frustrating Ad Workaround
    // https://arkadiumarena.visualstudio.com/Arena/_workitems/edit/83926/
    ((d) => {
        const head = d.head || d.getElementsByTagName('head')[0];
        const style = d.createElement('style');
        const css = '/* ARK: This style is a workaround on #83926 bug */\n#root .router-wrapper { height: initial; }';

        style.type = 'text/css';
        head.appendChild(style);

        // $FlowFixMe
        if (style.styleSheet) {
            // This is required for IE8 and below.
            // $FlowFixMe
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
    })(document);
}

export { loadScript } from '../common/load-script';
export { dynamicId } from '../common/dynamic-id';
export { isInViewport } from '../common/is-in-viewport';
